/**
 * SideMenu
 */

// React
import React, {useEffect, useState} from 'react';
import MessageRepository from 'client-sdk/src/Repository/message-repository';
import env from 'client-sdk/src/enviroments/enviroment'
// UI
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {
  Button,
  Paper,
  Typography,
  Badge,
  Popover,
  Grid,
} from '@material-ui/core';
import {Link, useHistory} from 'react-router-dom';
import VideosRepository from 'client-sdk/src/Repository/videos-repository';
import handleError from '../../utils/handleError';
import VideoModal from '../Modal/video';
import jMoment from 'moment-jalaali';
import {over} from 'stompjs';
import SockJs from 'sockjs-client';
import RonadIcons from '../iconComponent';
import IncreaseCredit from '../../pages/wallet/IncreaseCredit';
// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerBox: {
      marginLeft: '24px',

      marginBottom: '15px',
      marginTop: '15px',
    },
    icons: {
      cursor: 'pointer',
      display: 'block',
    },
    video: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: '#FEEAD37D',
      borderRadius: '4px',
      textDecoration: 'none',
      color: '#383836',
      padding: '6px 12px',
      marginRight: '50px',
    },
  })
);

const videos = {
  '/orders-create': {
    id : 10,
    name : "ایجاد سفارش",
    videoLength : 752,
    seenStatus : "SEEN",
    videoKey : "Create_order",
    aparatUrl : "https://www.aparat.com/video/video/embed/videohash/2wsg0/vt/frame"
  },
  '/orders': {
    id : 9,
    name : "سفارش",
    videoLength : 387,
    seenStatus : "SEEN",
    videoKey : "orders",
    aparatUrl : "https://www.aparat.com/video/video/embed/videohash/XF86M/vt/frame"
  },
  '/parcels-sender': {
    id : 5,
    name : "محموله",
    videoLength : 177,
    seenStatus : "SEEN",
    videoKey : "parcels",
    aparatUrl : "https://www.aparat.com/video/video/embed/videohash/30kWA/vt/frame"
  },
  '/your-products': {
    id : 2,
    name : "کالاها",
    videoLength : 0,
    seenStatus : "SEEN",
    videoKey : "Products",
    aparatUrl : "https://www.aparat.com/video/video/embed/videohash/R7eLq/vt/frame"
  },
  '/create-product': {
    id : 3,
    name : "تعریف کالای تکی",
    videoLength : 546,
    seenStatus : "SEEN",
    videoKey : "Create_product",
    aparatUrl : "https://www.aparat.com/video/video/embed/videohash/26hkp/vt/frame"
  },
  '/create-grouping-product': {
    id : 4,
    name : "تعریف گروهی کالا",
    videoLength : 350,
    seenStatus : "SEEN",
    videoKey : "Create_products",
    aparatUrl : "https://www.aparat.com/video/video/embed/videohash/8JPk7/vt/frame"
  },
  '/parcels-sender/add': {
    id : 6,
    name : "ایجاد محموله",
    videoLength : 375,
    seenStatus : "SEEN",
    videoKey : "Create_parcel",
    aparatUrl : "https://www.aparat.com/video/video/embed/videohash/jAGrX/vt/frame"
  },
  '/create-grouping-parcel': {
    "id" : 7,
    "name" : "ایجاد گروهی محموله",
    "videoLength" : 171,
    "seenStatus" : "SEEN",
    "videoKey" : "Create_parcels",
    "aparatUrl" : "https://www.aparat.com/video/video/embed/videohash/35rOA/vt/frame"
  },
  '/parcels-sender/:id/conflicts': {
    id : 8,
    name : "مغایرت",
    videoLength : 190,
    seenStatus : "SEEN",
    videoKey : "conflict",
    aparatUrl : "https://www.aparat.com/video/video/embed/videohash/35rOA/vt/frame"
  },
  '/packaging-preferences': {
    id : 12,
    name : "تنظیمات بسته‌بندی",
    videoLength : 182,
    seenStatus : "SEEN",
    videoKey : "package",
    aparatUrl : "https://www.aparat.com/video/video/embed/videohash/rcGPE/vt/frame"
  },
  '/alltickets': {
    id : 13,
    name : "پشتیبانی",
    videoLength : 418,
    seenStatus : "SEEN",
    videoKey : "ticketing",
    aparatUrl : "https://www.aparat.com/video/video/embed/videohash/DK5im/vt/frame"
  },
  '/financial-management': {
    id : 14,
    name : "مالی",
    videoLength : 80,
    seenStatus : "SEEN",
    videoKey : "financial",
    aparatUrl : "https://www.aparat.com/video/video/embed/videohash/rxmP1/vt/frame"
  }
};

export default function TopBar(props: any) {
  const history = useHistory();
  const classes = useStyles();
  const [videoLoading, setVideoLoading] = useState(false);
  const [openPopover, setOpenPopover] = useState(false);
  const [dialog, setDialog] = useState('');
  const [videoType, setVideoType] = useState('');
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const [notifications, setNotifications] = useState<any[]>([]);
  const [notification, setNotification] = useState({});
  const [notificationCount, setNotificationCount] = useState({});
  const [notificationCounts, setNotificationCounts] = useState(0);

  useEffect(() => {
    if(window.location.pathname.includes("/conflicts")) {
      setVideoType(videos["/parcels-sender/:id/conflicts"])
    }else {
      setVideoType(videos[window.location.pathname]);
    }
  }, [window.location.pathname]);
  useEffect(() => {
    connect();
  }, []);
  useEffect(() => {
    getNotification();
  }, [notification]);
  useEffect(() => {
    getNotificationCount();
  }, [notificationCount]);

  const getNotification = () => {
    const oldNotifications = [...notifications];
    const message = {...notification};
    if (notifications.length == 5 && message.title) {
      oldNotifications.shift();
      setNotifications([...oldNotifications, message]);
    } else if (message.title) {
      setNotifications([...oldNotifications, message]);
    }
  };
  const getNotificationCount = () => {
    let number = notificationCount.count;
    if (notificationCount.add) {
      number += notificationCounts;
    }
    setNotificationCounts(number);
  };
  const connect = () => {
    const socket = new SockJs(env.base_url + '/ronad-ws');
    const stompClient = over(socket);

    var customHeader = {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
      /*     Origin :  origin*/
    };

    stompClient.connect(customHeader, function (frame) {
      stompClient.subscribe('/topic/global-notifications', function (message) {
        const converted = JSON.parse(message.body);
        setNotification({...converted});
        setNotificationCount({count: 1, add: true});
      });

      stompClient.subscribe('/user/queue/private-message', function (message) {
        const messages = [];
        const converted = JSON.parse(message.body);
        messages.push(converted);
        setNotification(converted);
        setNotificationCount({count: 1, add: true});
      });
      stompClient.subscribe('/user/queue/not-seen-count', function (message) {
        const converted = JSON.parse(message.body);
        setNotificationCount({count: converted, add: false});
      });
      stompClient.subscribe(
        '/user/queue/private-message/former',
        function (message) {
          const converted = JSON.parse(message.body);
          setNotification(converted);
        }
      );
    });
  };
  const updateVideo = async (id: number) => {
    await VideosRepository.updateVideoStatus({
      payload: {id},
    });
  };
  const makeSeen = async (message: any) => {
    try {
      const callback = await MessageRepository.updateMessageStatus({
        payload: {
          body: {
            messageId: message.id,
            messageType: message.messageType,
          },
          callback: '',
        },
      });
    } catch (error) {
      handleError(error);
    }
  };
  const onVideoOpen = () => {
    setDialog('VIDEO');
    if(videoType?.seenStatus !== "SEEN") {
      updateVideo(videoType?.id)
    }
    // fetchVideo();
  };
  const handleClose = () => {
    setAnchorEl(null);
    setOpenPopover(false);
  };
  const clickNotificationHandler = event => {
    setAnchorEl(event.currentTarget);
    if (notifications.length > 0) {
      setOpenPopover(true);
    }
  };
  const showAllMessagesHandler = () => {
    history.push(`/messages`);
    setOpenPopover(false);
  };
  
  return (
    <>
      <Paper
        style={{
          //   width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '66px',
          borderRadius: '0',
          zIndex: 4,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '97px',
          left: '24px',
          paddingRight: '24px',
          paddingLeft: '48px',
          borderBottomLeftRadius: '4px',
          borderBottomRightRadius: '4px',
        }}
      >
        <Typography component="p">به پنل روناد خوش آمدید</Typography>
        {process.env.REACT_APP_ENVIROMENT === "sandbox" && <Typography component="p" style={{fontWeight: "bold"}}>پنل دمو</Typography>}
        <div style={{display: 'flex', alignItems: 'center'}}>
          <IncreaseCredit />
          {videoType && (
            <Button onClick={onVideoOpen} className={classes.video}>
              <span style={{marginLeft: '24px'}}>{videoType.name}</span>
              <RonadIcons name='cameraMovie' title='ویدئوها' className='pointer text-orange'/>
            </Button>
          )}
          <Badge
            badgeContent={notificationCounts}
            color="error"
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            style={{marginRight: '12px'}}
            onClick={e => {
              clickNotificationHandler(e);
            }}
          >
            <RonadIcons name='bell' title='پیام ها' className='pointer ml-2' style={{marginTop: "-3px"}}/>
          </Badge>
          <Link to="/alltickets">
            <RonadIcons name='headset' title='پشتیبانی' className='pointer text-black ml-2'/>
          </Link>
          <Link to="/profile">
            <RonadIcons name='user' title='حساب کاربری' className='pointer text-black'/>
          </Link>
        </div>
      </Paper>
      <VideoModal
        src={videoType?.aparatUrl}
        onClose={() => setDialog('')}
        open={dialog === 'VIDEO'}
        loading={videoLoading}
      />
      <Popover
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Grid
          container
          style={{maxWidth: '400px', maxHeight: '400px', padding: '24px'}}
          xs={12}
        >
          <Grid item xs={12}>
            <div style={{fontSize: '18px', fontWeight: '700'}}>
              {'آخرین پیام‌ها'}
            </div>
          </Grid>
          <Grid
            container
            item
            xs={12}
            style={{
              maxHeight: '250px',
              overflow: 'auto',
              direction: 'ltr',
              marginTop: '24px',
            }}
          >
            {notifications.map((notif, index) => {
              return (
                <Grid
                  xs={12}
                  style={{
                    padding: '12px',
                    borderBottom: '1px solid rgba(37, 54, 140, 0.2)',
                    direction: 'rtl',
                    cursor:
                      (notif.messageType == 'GENERAL' ||
                        notif.messageType == 'GENERAL_PRIVATE') &&
                      'pointer',
                  }}
                  item
                  container
                  onClick={() => {
                    if (
                      notif.messageType == 'GENERAL' ||
                      notif.messageType == 'GENERAL_PRIVATE'
                    ) {
                      history.push(
                        `/messages?id=${notif.id}&messageType=${notif.messageType}`
                      );
                      setOpenPopover(false);
                    } else {
                      makeSeen(notif);
                      setOpenPopover(false);
                    }
                  }}
                >
                  <Grid spacing={2} xs={12} item container>
                    {!notif.seen && (
                      <Grid item xs={1}>
                        <div
                          style={{
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: '#25368C',
                          }}
                        ></div>
                      </Grid>
                    )}
                    <Grid
                      style={{fontSize: '16px', fontWeight: '700'}}
                      item
                      xs={9}
                    >
                      {notif.title}
                    </Grid>
                  </Grid>
                  <Grid
                    style={{
                      fontSize: '14px',
                      fontWeight: '400',
                      color: '#3838368F',
                    }}
                    xs={12}
                    item
                  >
                    <span>
                      {`${jMoment(notif.created.split("T")[1], 'HH:mm:ss')
                            .add(3, "hours")
                            .add(30,"minutes")
                            .locale('fa')
                            .format('HH:mm:ss')}
                      `}
                    </span>
                    &nbsp;- &nbsp;
                    <span>
                      {jMoment(notif.created, 'YYYY/M/D')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}
                    </span>
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
          <Grid style={{textAlign: 'left'}} item xs={12}>
            <span
              onClick={showAllMessagesHandler}
              style={{
                fontSize: '14px',
                fontWeight: '400',
                color: '#25368C',
                padding: '12px',
                cursor: 'pointer',
                display: 'inline-block',
              }}
            >
              {'مشاهده تمام پیام‌ها'}
            </span>
          </Grid>
        </Grid>
      </Popover>
    </>
  );
}
